import { AxiosDefault } from "@/plugins/axios";
import { Ware, WareDetection, AppInformationItem } from "./ware.interface";

export class WareService {
  /**
   * 获取某个apk检测的详细信息，包括检测历史记录
   * @param id apkID
   */
  static async getWare(packageName: any): Promise<Ware> {
    const { data } = await AxiosDefault.get(
      `/bff/rule/ware/appDetail?packageName=${packageName}`
    );
    return data;
  }

  static async getOneAppWare(id: string): Promise<AppInformationItem> {
    const { data } = await AxiosDefault.get(
      `/bff/user/notice/networkTags?id=${id}`
    );
    return data || {};
  }
}
